/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationBaseForFreshservice extends models.GovernanceConfigurationBaseForItsm {
    getFixupPrototypeFunction() { return GovernanceConfigurationBaseForFreshservice.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationBaseForFreshservice>): GovernanceConfigurationBaseForFreshservice {
        let obj = Object.assign(new GovernanceConfigurationBaseForFreshservice(), model);
        GovernanceConfigurationBaseForFreshservice.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationBaseForFreshservice>): GovernanceConfigurationBaseForFreshservice {
        if (!model) return null;
        return GovernanceConfigurationBaseForFreshservice.newInstance(<GovernanceConfigurationBaseForFreshservice> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationBaseForFreshservice) {
        if (!obj) return;

        models.GovernanceConfigurationBaseForFreshservice.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationBaseForFreshservice): boolean {
        if (models.GovernanceConfigurationBaseForItsm.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationBaseForFreshservice.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
